import { render, staticRenderFns } from "./CreateAccountTeaser.vue?vue&type=template&id=6ce45060&scoped=true"
import script from "./CreateAccountTeaser.vue?vue&type=script&lang=js"
export * from "./CreateAccountTeaser.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountTeaser.vue?vue&type=style&index=0&id=6ce45060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce45060",
  null
  
)

export default component.exports